<template class="white-content">
  <div id="app">
    <div class="content">
      <keep-alive>
        <router-view :key="$route.fullPath">
        </router-view>
      </keep-alive>
    </div>

    <div class="content">
      <downloading-modal>
        Downloading modal
      </downloading-modal>
    </div>

  </div>
</template>

<script>

import DownloadingModal from "@/components/DownloadingModal.vue";

  export default {
    components: {
      DownloadingModal
    },
    methods: {
      disableRTL() {
        if (!this.$rtl.isRTL) {
          this.$rtl.disableRTL();
        }
      },
      toggleNavOpen() {
        let root = document.getElementsByTagName('html')[0];
        root.classList.toggle('nav-open');
      }
    },
    mounted() {
      this.$watch('$route', this.disableRTL, { immediate: true });
      this.$watch('$sidebar.showSidebar', this.toggleNavOpen)
    }
  };
</script>

<style lang="scss">
#app {
  // font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
